import {Component, OnInit} from '@angular/core';
import {SpecializationsService} from "../../../specializations/services/specializations.service";
import {
  AdvancedLevelModel, AnswerModel,
  BeginnerLevelModel,
  PositionModel,
  QuestionSpecializationModel,
  SpecializationModel
} from "../../../specializations/models/learning.model";
import {LearningService} from "../../service/learning.service";
import {Router} from "@angular/router";
import {UserService} from "../../../../../services/user.service";
import {Answer, Question, TestingModel, LevelQAInResources} from "../../models/user-testing.model";
import {AdminService} from "../../../../../services/admin.service";


@Component({
  selector: 'app-start-learning',
  templateUrl: './start-learning.component.html',
  styleUrls: ['./start-learning.component.css']
})
export class StartLearningComponent implements OnInit {

  constructor(private specializationsServ: SpecializationsService,
              private learningServ: LearningService,
              private router: Router,
              private userService: UserService,
              private adminService: AdminService
  ) {
  }

  isLoaded = false;
  operationSuccess = false;
  operationFail = false;
  activeTab = 'tab1';

  id = this.specializationsServ.nodeId;

  specialization: SpecializationModel;
  question: QuestionSpecializationModel;
  answer: AnswerModel;
  beginnerLevels: Array<BeginnerLevelModel>;
  advancedLevels: Array<AdvancedLevelModel>;
  position = PositionModel;

  level_1: BeginnerLevelModel;
  level_2: BeginnerLevelModel;
  level_3: AdvancedLevelModel;
  level_4: AdvancedLevelModel;
  level_5: AdvancedLevelModel;

  testingAnswersModel: TestingModel;
  btn = false;
  userLang = '';
  isEnglish: boolean;
  currentLevelId = '';
  selectTab;
  isCheckingAnswers = false;
  currentLevel;
  status;
  currentLevelBegin;
  remoteAccessError;

  ngOnInit() {
    this.currentLevel = this.learningServ.nodeLevel;
    this.isLevelTwoBlocked();
    this.checkUserLang();
    this.testingAnswersModel = new TestingModel([]);
    this.specialization = new SpecializationModel(null, null, null, false, false, [], []);
    this.getSpec();

    // Check if nodeName is empty and redirect if true
    if (this.learningServ.nodeName === '') {
      this.router.navigateByUrl('/dashboard/learning');
    }
  }

  checkLevel(id) {
    this.status  = '';
    this.adminService.checkLevel(id.id).subscribe(
      (res: any) => {
        this.btn = false;
        if(res.body.advancedLevelTaskStatus !== 'COMPLETE') {
          this.currentLevelBegin = res.body;
          this.status = this.currentLevelBegin.advancedLevelTaskStatus;
        }
        if(this.status) {
          this.renameTypes(this.status);
        }
      },
      (err: any) => {
        
        this.btn = true; 
      }
    );
    this.selectTab = id;
  }

  renameTypes(status) {
    if(status === 'IN_WORK') {
      this.status = 'In work'
    } 
    if(status === 'IN_PROCESSING') {
      this.status = 'In processing'
    }   
    if(status === 'COMPLETE') {
      this.status = 'Complete'
    } 
  }

  send() {
    this.adminService.pushTask(this.selectTab.id).subscribe(
      (res: any) => {
        this.btn = false;
        this.currentLevelBegin = res;
        this.status = this.currentLevelBegin.advancedLevelTaskStatus;
        if(this.status) {
          this.renameTypes(this.status);
        }
      },
      (err: any) => {
        this.remoteAccessError = err.error.message;
        setTimeout(() => this.remoteAccessError = '', 5000);
        this.btn = false;
      }
    );
  }

  isLevelTwoBlocked() {
    if (this.learningServ.nodeLevel === null && this.activeTab === 'tab2') {
      return true;
    }
  }

  isCheckAnswBtnDisabled() {
    if (this.activeTab === 'tab3' || this.activeTab === 'tab4' || this.activeTab === 'tab5') {
      return true;
    }
  }

  isContentDisabled() {
    const level = this.learningServ.nodeLevel;
    if (this.activeTab === 'tab1') {
      if (level > '0') {
        return true;
      }
    } else if (this.activeTab === 'tab2') {
      if (level > '1') {
        return true;
      }
    }
    if (level > '2') {
      return true;
    }
  }

  validateContent(questionList) {
    let flag = true;
    questionList.forEach(question => {
      if (question.questionText.trim().length < 1) {
        flag = false;
      }
    });
    return flag;
  }

  isEmptyQuestion() {
    if (this.isEnglish) {
      if (this.activeTab === 'tab1') {
        return this.validateContent(this.specialization.beginnerLevels[0].enQuestions);
      }
      if (this.activeTab === 'tab2') {
        return this.validateContent(this.specialization.beginnerLevels[1].enQuestions);
      }
    }

    if (!this.isEnglish) {
      if (this.activeTab === 'tab1') {
        return this.validateContent(this.specialization.beginnerLevels[0].ruQuestions);
      }
      if (this.activeTab === 'tab2') {
        return this.validateContent(this.specialization.beginnerLevels[1].ruQuestions);
      }
    }
    return false;
  }

  getSpec() {
    this.learningServ.getSingleSpec().subscribe(
      (res: any) => {
        this.specialization = res.body;
        this.level_1 = this.specialization.beginnerLevels[0];
        this.level_2 = this.specialization.beginnerLevels[1];
        if(this.specialization.advancedLevels[0] && this.specialization.advancedLevels[0].ruRequirements.length !== 0) {
          this.level_3 = this.specialization.advancedLevels[0];
        }
        if(this.specialization.advancedLevels[1] && this.specialization.advancedLevels[1].ruRequirements.length !== 0) {
          this.level_4 = this.specialization.advancedLevels[1];
        }
        if(this.specialization.advancedLevels[2] && this.specialization.advancedLevels[2].ruRequirements.length !== 0) {
          this.level_5 = this.specialization.advancedLevels[2];
        }
        this.isLoaded = true;
        switch (this.activeTab) {
          case 'tab1': {
            this.currentLevelId = this.specialization.beginnerLevels[0].id;
            break;
          }
        }
      },
      () => {
      }
    );
  }

  checkVideo(link) {
    return link !== '';
  }

  checkUserLang() {
    this.userLang = this.userService.getLocal().language;
    if (this.userLang === "russian") {
      this.isEnglish = false;
    } else {
      this.isEnglish = true;
    }
  }

  setActiveLevel(event) {
    this.activeTab = event.nextId;
    switch (this.activeTab) {
      case 'tab1': {
        this.currentLevelId = this.specialization.beginnerLevels[0].id;
        break;
      }
      case 'tab2': {
        this.currentLevelId = this.specialization.beginnerLevels[1].id;
        break;
      }
      default: {
        break;
      }
    }
  }

  setUserAnswer(question: Question, answer: Answer) {
    if (this.testingAnswersModel.levelQAInResources.length > 0) {
      let found = false;
      let index = null;
      for (const item of this.testingAnswersModel.levelQAInResources) {
        if (item.question.questionText === question.questionText) {
          found = true;
          index = this.testingAnswersModel.levelQAInResources.indexOf(item);
        }
      }
      if (found) {
        this.testingAnswersModel.levelQAInResources.splice(index, 1);
        this.testingAnswersModel.levelQAInResources.push(new LevelQAInResources(question, answer));
      } else {
        this.testingAnswersModel.levelQAInResources.push(new LevelQAInResources(question, answer));
      }
    } else {
      this.testingAnswersModel.levelQAInResources.push(new LevelQAInResources(question, answer));
    }
  }

  showSelectedAnswer(question) {
    let answer = "";
    if (this.testingAnswersModel.levelQAInResources.length > 0) {
      this.testingAnswersModel.levelQAInResources.forEach(qObj => {
        if (qObj.question.questionText === question.questionText) {
          answer = qObj.answer.answerText;
        }
      });
    }
    return answer;
  }

  isCheckBtnDisabled() {
    if (this.activeTab === 'tab1') {
      if (this.isEnglish) {
        return this.testingAnswersModel.levelQAInResources.length === this.specialization.beginnerLevels[0].enQuestions.length;
      } else {
        return this.testingAnswersModel.levelQAInResources.length === this.specialization.beginnerLevels[0].ruQuestions.length;
      }
    } else if (this.activeTab === 'tab2') {
      if (this.isEnglish) {
        return this.testingAnswersModel.levelQAInResources.length === this.specialization.beginnerLevels[1].enQuestions.length;
      } else {
        return this.testingAnswersModel.levelQAInResources.length === this.specialization.beginnerLevels[1].ruQuestions.length;
      }
    } else {
      return false;
    }
  }

  checkAnswer() {
    this.isCheckingAnswers = true;
    this.adminService.checkUserAnswers(this.currentLevelId, this.testingAnswersModel).subscribe(
      (response: any) => {
        if (response.status === 200) {
          this.learningServ.testPassed = true;
          this.learningServ.testFailed = false;
          this.isCheckingAnswers = false;
          this.operationFail = false;
          this.router.navigateByUrl('/dashboard/learning');
        }
      },
      (err) => {
        if (err.status === 400) {
          this.learningServ.testPassed = false;
          this.learningServ.testFailed = true;
          this.isCheckingAnswers = false;
          this.operationFail = false;
          this.router.navigateByUrl('/dashboard/learning');
        }
        if (err.status === 502) {
          this.operationFail = true;
          this.isCheckingAnswers = false;
        }
      }
    );

  }

  goToLink(link: string) {
    if (!link.includes('http')) {
      link = 'http://' + link;
    }
    window.open(link, '_blank');
  }

  downloadFile(id) {
    this.userService.getFile(id).subscribe(
      (response: any) => {
        const link = document.createElement('a');
        link.href = window.URL.createObjectURL(response.body);
        link.download = response.headers.get('filename');
        link.click();
        link.remove();
      },
      () => {
      }, () => {
      }
    );
  }
}




// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/content-page/common/learning/components/start-learning/start-learning.component.ts